import {
  faBarcode as faBarcode,
  faGhost as faGhost,
  faImage as farImage,
  faArrowDown as farArrowDown,
  faArrowUp as farArrowUp,
  faPencil as farPencil,
  faQuestionCircle as farQuestionCircle,
  faKey as farKey,
  faEnvelope as farEnvelope,
  faSignInAlt as farSignInAlt,
  faLock as farLock,
  faUnlock as farUnlock,
  faLockOpen,
  faSave,
  faSave as farSave,
  faCircleNotch as farCircleNotch,
  faBadgeCheck as farBadgeCheck,
  faEllipsisV as farEllipsesV,
  faChevronDown as farChevronDown,
  faFolder as farFolder,
  faFolderPlus as farFolderPlus,
  faChevronLeft as farChevronLeft,
  faChevronRight as farChevronRight,
  faTimes as farTimes,
  faCheck as farCheck,
  faUser as farUser,
  faChevronUp as farChevronUp,
  faSearch as farSearch,
  faSearchPlus as farSearchPlus,
  faSearchMinus as farSearchMinus,
  faSignOutAlt,
  faFileUser,
  faThLarge,
  faThList as farThList,
  faPlusSquare as farPlusSquare,
  faEdit,
  faTrashAlt as farTrashAlt,
  faTimesCircle,
  faClock,
  faList,
  faEye as farEye,
  faGlobe,
  faStickyNote as farStickyNote,
  faLongArrowLeft,
  faPaperclip,
  faRedoAlt as farRedoAlt,
  faLink,
  faPortrait as farPortrait,
  faStream,
  faFileImport,
  faFileImport as farFileImport,
  faExchange,
  faMinusCircle,
  faComment as farComment,
  faSyncAlt as farSyncAlt,
  faCheckCircle,
  faInfoCircle,
  faExclamationTriangle as farExclamationTriangle,
  faEyeSlash,
  faExpandAlt,
  faCompressAlt,
  faWindowMaximize,
  faSpinner,
  faArrowSquareLeft,
  faLongArrowRight,
  faArrowRightLong,
  faPassport as farPassport,
  faPlay,
  faClipboardListCheck,
  faSplit as farSplit,
  faArrowsAlt as farArrowsAlt,
  faPlayCircle as farPlayCircle,
  faRepeat as farRepeat,
  faUpload as farUpload,
  faAngleDoubleLeft,
  faAngleLeft,
  faAngleDown
} from '@fortawesome/pro-regular-svg-icons';
import {
  faCheckCircle as falCheckCircle,
  faLongArrowLeft as falLongArrowLeft,
  faUserShield as falUserShield,
  faTasks as falTasks,
  faTasks,
  faArchive as falArchive,
  faBuilding,
  faCity,
  faThList,
  faCogs,
  faUsersCrown,
  faChartBar as falChartBar,
  faGlobeAfrica,
  faUsers as falUsers,
  faUsers,
  faPortrait,
  faPeopleCarry,
  faListUl,
  faProjectDiagram,
  faExclamationTriangle,
  faWallet,
  faArrowSquareLeft as falArrowSquareLeft,
  faCircle,
  faFolder as falFolder,
  faSlidersV,
  faAngleRight,
  faSearch,
  faTruckFast as falTruckFast,
  faLanguage,
  faCheck as falCheck,
  faPeopleGroup as falPeopleGroup,
  faArrowCircleRight,
  faCalendarPen,
  faHouse,
  faPenToSquare,
  faBarcodeRead,
  faFileCirclePlus
} from '@fortawesome/pro-light-svg-icons';
import {
  faBoxOpen,
  faExchange as fasExchange,
  faFileInvoice,
  faFilePdf,
  faMobileAlt as fasMobileAlt,
  faUserFriends as fasUserFriends,
  faChevronCircleRight as fasChevronCircleRight,
  faChevronRight as fasChevronRight,
  faCheck as fasCheck,
  faPencil,
  faFileInvoiceDollar as fileInvoiceDollar,
  faUsersCog as fasUsersCog,
  faQuestionCircle as fasQuestionCircle,
  faSearch as fasSearch,
  faCaretDown,
  faCaretUp,
  faCloudUpload,
  faFileAlt,
  faFile,
  faCopy,
  faArchive,
  faThLarge as fasThLarge,
  faTh,
  faChartPie,
  faColumns,
  faCloudDownloadAlt,
  faPaperPlane,
  faPlusSquare as fasPlusSquare,
  faPlusSquare,
  faMinusSquare,
  faCaretRight,
  faTrashAlt,
  faCalendarEdit,
  faCalendarPlus,
  faCalendarCheck,
  faCircleNotch as fasCircleNotch,
  faTimesCircle as fasTimesCircle,
  faThumbsUp,
  faThumbsDown,
  faCog,
  faUserCircle,
  faEye,
  faFolder as fasFolder,
  faFolder,
  faFolderOpen,
  faPlus,
  faEnvelope,
  faUser as fasUser,
  faUsers as fasUsers,
  faStickyNote,
  faChartBar,
  faDownload,
  faGripHorizontal,
  faRedoAlt,
  faUserPlus,
  faLockAlt,
  faUnlockAlt,
  faClipboard,
  faClipboardCheck,
  faUserEdit,
  faMapMarkerAlt,
  faFileEdit,
  faPlayCircle,
  faExternalLinkSquareAlt,
  faClone,
  faExternalLinkSquare,
  faInfoSquare,
  faArrowAltRight,
  faBuilding as fasBuilding,
  faGlobeAsia,
  faGlobeAsia as fasGlobeAsia,
  faCheckSquare,
  faTimesSquare,
  faExclamationTriangle as fasExclamationTriangle,
  faFastBackward,
  faBackward,
  faFastForward,
  faForward,
  faBars as fasBars,
  faStar,
  faMapPin,
  faLocationCircle,
  faComments as fasComments,
  faCode,
  faUserSecret,
  faEdit as fasEdit,
  faCheckCircle as fasCheckCircle,
  faLockOpenAlt,
  faExclamationCircle,
  faCaretLeft,
  faArrowUpRightFromSquare,
  faCircleInfo as fasCircleInfo,
  faOctagonXmark as fasOctagonXmark,
  faSplit as faSplit,
  faCloudArrowUp,
  faLanguage as fasLanguage,
  faOctagonExclamation
} from '@fortawesome/pro-solid-svg-icons';

export const APP_MODULE_ICONS = [
  faBarcode,
  faGhost,
  farKey,
  farEnvelope,
  farSignInAlt,
  farLock,
  farUnlock,
  faLockOpen,
  farSave,
  farCircleNotch,
  fasMobileAlt,
  farBadgeCheck,
  falLongArrowLeft,
  fasUserFriends,
  farEllipsesV,
  fasChevronCircleRight,
  fasChevronRight,
  farChevronDown,
  farFolder,
  farFolderPlus,
  fasCheck,
  farChevronLeft,
  farChevronRight,
  faPencil,
  falUserShield,
  farTimes,
  fileInvoiceDollar,
  fasUsersCog,
  farCheck,
  farUser,
  farChevronUp,
  farQuestionCircle,
  faSearch,
  farSearch,
  fasSearch,
  farSearchPlus,
  farSearchMinus,
  faSignOutAlt,
  faCaretDown,
  faCaretUp,
  faSave,
  faCloudUpload,
  faAngleRight,
  faFileAlt,
  faFile,
  faFileUser,
  faCopy,
  faArchive,
  faThLarge,
  fasThLarge,
  faTh,
  faChartPie,
  faColumns,
  faCloudDownloadAlt,
  faPaperPlane,
  faPlusSquare,
  faMinusSquare,
  faCaretRight,
  faTasks,
  falArchive,
  faBuilding,
  faCity,
  faThList,
  farThList,
  faCogs,
  faUsersCrown,
  farPlusSquare,
  faEdit,
  farTrashAlt,
  faCalendarEdit,
  faCalendarPlus,
  faCalendarCheck,
  fasCircleNotch,
  faTimesCircle,
  fasTimesCircle,
  faThumbsUp,
  faThumbsDown,
  faClock,
  faList,
  faCog,
  faUserCircle,
  faEye,
  farEye,
  faFolder,
  faFolderOpen,
  faPlus,
  faPencil,
  faEnvelope,
  farEnvelope,
  fasUser,
  fasUsers,
  faGlobe,
  faStickyNote,
  faLongArrowLeft,
  faChartBar,
  falChartBar,
  faDownload,
  faPaperclip,
  faGripHorizontal,
  faGlobeAfrica,
  faUsers,
  faRedoAlt,
  farRedoAlt,
  faUserPlus,
  faLink,
  faLockAlt,
  faUnlockAlt,
  faClipboard,
  faClipboardCheck,
  faUserEdit,
  faMapMarkerAlt,
  faFileEdit,
  faPlayCircle,
  faExternalLinkSquareAlt,
  faClone,
  faPortrait,
  farPortrait,
  faExternalLinkSquare,
  faInfoSquare,
  faPeopleCarry,
  faProjectDiagram,
  faStream,
  faArrowAltRight,
  fasBuilding,
  fasGlobeAsia,
  farFileImport,
  faCheckSquare,
  faTimesSquare,
  fasExclamationTriangle,
  faFastBackward,
  faBackward,
  faFastForward,
  faForward,
  fasBars,
  faListUl,
  faExchange,
  faMinusCircle,
  faStar,
  faMapPin,
  faLocationCircle,
  fasComments,
  farComment,
  faCode,
  farSyncAlt,
  faUserSecret,
  fasEdit,
  faInfoCircle,
  faTimesCircle,
  faExclamationTriangle,
  farExclamationTriangle,
  faCheckCircle,
  falCheckCircle,
  fasCheckCircle,
  fasQuestionCircle,
  fasPlusSquare,
  faEyeSlash,
  faLockOpenAlt,
  faExpandAlt,
  faCompressAlt,
  faExclamationCircle,
  faWindowMaximize,
  faSpinner,
  faPlusSquare,
  faSave,
  faTimesCircle,
  fasTimesCircle,
  faEdit,
  faTrashAlt,
  faPaperclip,
  falTasks,
  faWallet,
  faArrowSquareLeft,
  falArrowSquareLeft,
  faCircle,
  faLongArrowRight,
  faFileImport,
  faGlobeAsia,
  falFolder,
  fasFolder,
  farPassport,
  faPlay,
  falUsers,
  faClipboardListCheck,
  faBoxOpen,
  faFileInvoice,
  farPencil,
  fasExchange,
  faSlidersV,
  farStickyNote,
  faFilePdf,
  farImage,
  farArrowDown,
  farArrowUp,
  faCaretLeft,
  faArrowUpRightFromSquare,
  falTruckFast,
  faLanguage,
  fasCircleInfo,
  falCheck,
  falPeopleGroup,
  fasOctagonXmark,
  faSplit,
  farSplit,
  farArrowsAlt,
  faCloudArrowUp,
  faArrowCircleRight,
  fasLanguage,
  faCalendarPen,
  faHouse,
  faPenToSquare,
  faBarcodeRead,
  faFileCirclePlus,
  faArrowRightLong,
  faOctagonExclamation,
  farPlayCircle,
  farRepeat,
  farUpload,
  faAngleDoubleLeft,
  faAngleLeft,
  faAngleDown
];
